import { ModelOptions } from './model-options';

export class ArrayModelOptions extends ModelOptions {
    public readonly maxEntries: number;
    public constructor({ maxEntries = Infinity }: { maxEntries?: number } = {}) {
        super();
        this.maxEntries = maxEntries;
    }
}

export class ArrayModelOptionsFromJson extends ArrayModelOptions {
    public constructor(data: JsonArrayModelOptions) {
        super({
            maxEntries: data.maxEntries ? data.maxEntries : Infinity,
        });
    }
}

export interface JsonArrayModelOptions {
    maxEntries: number;
}
